module.exports = __webpack_public_path__ + "static/fonts/SourceHanSerifCN-Regular-1.473303fb.otf";